import { render, staticRenderFns } from "./batchPledge.vue?vue&type=template&id=01f25ba4&scoped=true&"
import script from "./batchPledge.vue?vue&type=script&lang=js&"
export * from "./batchPledge.vue?vue&type=script&lang=js&"
import style0 from "./batchPledge.vue?vue&type=style&index=0&id=01f25ba4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f25ba4",
  null
  
)

export default component.exports